// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import responsive styles */
/* Estilos responsive para OHIF Viewer */
/* Mobile-first approach */
@media (max-width: 768px) {
  .mobile-layout {
    /* Optimizaciones específicas para móvil */
    -webkit-overflow-scrolling: touch;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
  }

  /* Header completamente oculto en móvil */
  .mobile-layout .viewer-header {
    display: none !important;
  }

  /* Panel de herramientas móvil - aparece desde abajo */
  .mobile-tools-panel {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    background: rgba(10, 15, 20, 0.95) !important;
    backdrop-filter: blur(10px) !important;
    border-top: 1px solid #2d3748 !important;
    z-index: 9999 !important;
    padding: 16px !important;
    transform: translateY(100%) !important;
    transition: transform 0.3s ease-in-out !important;
    max-height: 70vh !important;
    overflow-y: auto !important;
  }

  .mobile-tools-panel.open {
    transform: translateY(0) !important;
  }

  /* Botón flotante para abrir herramientas */
  .mobile-tools-button {
    position: fixed !important;
    bottom: 20px !important;
    right: 20px !important;
    width: 56px !important;
    height: 56px !important;
    background: #3182ce !important;
    border-radius: 50% !important;
    border: none !important;
    color: white !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    z-index: 10000 !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4) !important;
    transition: all 0.2s ease !important;
  }

  .mobile-tools-button:active {
    transform: scale(0.95) !important;
    background: #2c5aa0 !important;
  }

  /* Grid de herramientas en el panel móvil */
  .mobile-tools-grid {
    display: grid !important;
    grid-template-columns: repeat(4, 1fr) !important;
    gap: 16px !important;
    padding: 8px 0 !important;
  }

  .mobile-tool-item {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    padding: 12px 8px !important;
    background: rgba(45, 55, 72, 0.6) !important;
    border-radius: 8px !important;
    border: 1px solid #4a5568 !important;
    min-height: 80px !important;
    justify-content: center !important;
    text-align: center !important;
    transition: all 0.2s ease !important;
  }

  .mobile-tool-item:active {
    background: rgba(66, 153, 225, 0.3) !important;
    transform: scale(0.95) !important;
  }

  .mobile-tool-item .icon {
    margin-bottom: 4px !important;
    width: 24px !important;
    height: 24px !important;
  }

  .mobile-tool-item .label {
    font-size: 11px !important;
    color: #e2e8f0 !important;
    font-weight: 500 !important;
    line-height: 1.2 !important;
  }

  /* Header del panel móvil */
  .mobile-panel-header {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    margin-bottom: 16px !important;
    padding-bottom: 12px !important;
    border-bottom: 1px solid #4a5568 !important;
  }

  .mobile-panel-title {
    color: #e2e8f0 !important;
    font-size: 18px !important;
    font-weight: 600 !important;
  }

  .mobile-panel-close {
    background: none !important;
    border: none !important;
    color: #a0aec0 !important;
    font-size: 24px !important;
    padding: 4px !important;
    cursor: pointer !important;
  }

  /* Viewport optimizado para móvil - ocupa toda la pantalla */
  .mobile-viewport {
    touch-action: pan-x pan-y pinch-zoom !important;
    height: 100vh !important;
    width: 100vw !important;
  }

  /* Ocultar paneles laterales completamente en móvil */
  .mobile-layout .ohif-scrollbar,
  .mobile-layout .side-panel,
  .mobile-layout [class*="panel"],
  .mobile-layout .resize-handle {
    display: none !important;
  }

  /* Asegurar que el viewport ocupe todo el espacio */
  .mobile-layout .viewport-grid {
    height: 100vh !important;
    width: 100vw !important;
  }

  /* Overlay para cerrar panel */
  .mobile-panel-overlay {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    background: rgba(0, 0, 0, 0.3) !important;
    z-index: 9998 !important;
  }

  /* Información del paciente compacta en móvil */
  .mobile-patient-info {
    position: fixed !important;
    top: 10px !important;
    left: 10px !important;
    background: rgba(10, 15, 20, 0.8) !important;
    padding: 8px 12px !important;
    border-radius: 6px !important;
    font-size: 12px !important;
    color: #e2e8f0 !important;
    z-index: 9000 !important;
    backdrop-filter: blur(5px) !important;
  }
}
/* Tablet styles */
@media (min-width: 768px) and (max-width: 1024px) {
  .tablet-layout {
    /* Estilos específicos para tablet */
    touch-action: manipulation;
  }
}
/* Orientación específica */
@media (orientation: portrait) and (max-width: 768px) {
  .mobile-layout {
    /* Ajustes específicos para modo retrato en móvil */
    padding-bottom: env(safe-area-inset-bottom);
  }

  .mobile-header {
    height: 44px !important;
  }

  .mobile-panel {
    top: 44px !important;
  }
}
@media (orientation: landscape) and (max-width: 768px) {
  .mobile-layout {
    /* Ajustes específicos para modo paisaje en móvil */
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }

  .mobile-header {
    height: 40px !important;
  }

  .mobile-panel {
    top: 40px !important;
    max-width: 280px !important;
  }
}
/* Navbar del paciente en móvil */
@media (max-width: 768px) {
  .mobile-patient-navbar {
    position: absolute !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    background: rgba(0, 0, 0, 0.85) !important;
    backdrop-filter: blur(10px) !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
    padding: 8px 12px !important;
    z-index: 9000 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    height: 60px !important;
  }

  /* Viewport móvil con margen superior para el navbar */
  .mobile-viewport-with-navbar {
    position: relative !important;
    flex: 1 !important;
    width: 100vw !important;
    height: calc(100vh - 60px) !important;
    margin-top: 60px !important;
    background: black !important;
    overflow: hidden !important;
  }

  /* Botones de navegación inferior */
  .mobile-bottom-buttons {
    position: fixed !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    background: rgba(0, 0, 0, 0.9) !important;
    backdrop-filter: blur(10px) !important;
    border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
    padding: 12px !important;
    z-index: 10000 !important;
    display: flex !important;
    gap: 12px !important;
    justify-content: center !important;
    height: 72px !important;
  }

  .mobile-bottom-button {
    flex: 1 !important;
    max-width: 150px !important;
    height: 48px !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-radius: 8px !important;
    color: white !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    cursor: pointer !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 8px !important;
    transition: all 0.2s ease !important;
  }

  .mobile-bottom-button:hover {
    background: rgba(255, 255, 255, 0.2) !important;
  }

  .mobile-bottom-button.active {
    background: #3182ce !important;
  }
}
/* Utilities */
.mobile-hidden {
  display: none !important;
}
@media (min-width: 768px) {
  .mobile-hidden {
    display: block !important;
  }
}
.desktop-hidden {
  display: block !important;
}
@media (min-width: 768px) {
  .desktop-hidden {
    display: none !important;
  }
}
/* CUSTOM OHIF SCROLLBAR */
.ohif-scrollbar {
  scrollbar-color: #173239 transparent;
  overflow-y: auto;
}
.ohif-scrollbar-stable-gutter {
  scrollbar-gutter: stable;
}
.study-min-height {
  min-height: 450px;
}
.ohif-scrollbar:hover {
  overflow-y: auto;
}
.ohif-scrollbar::-webkit-scrollbar {
  scrollbar-width: thin;
}
.ohif-scrollbar::-webkit-scrollbar-track {
  border-radius: 0.25rem;
}
.ohif-scrollbar::-webkit-scrollbar-thumb {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(4 28 74 / var(--tw-bg-opacity));
  background-color: #041c4a;
}
.ohif-scrollbar::-webkit-scrollbar-thumb:window-inactive {
  --tw-bg-opacity: 1;
  background-color: rgb(4 28 74 / var(--tw-bg-opacity));
  background-color: #041c4a;
}
/* INVISIBLE SCROLLBAR */
.invisible-scrollbar {
  scrollbar-width: none;
}
.invisible-scrollbar::-webkit-scrollbar {
  display: none;
}
.invisible-scrollbar::-webkit-scrollbar-track {
  display: none;
}
.invisible-scrollbar::-webkit-scrollbar-thumb {
  display: none;
}
.invisible-scrollbar::-webkit-scrollbar-thumb:window-inactive {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./../../ui-next/src/assets/styles.css","webpack://./../../ui-next/src/styles/responsive.css"],"names":[],"mappings":"AAAA,6BAA6B;ACA7B,wCAAwC;AAExC,0BAA0B;AAC1B;EACE;IACE,0CAA0C;IAC1C,iCAAiC;IACjC,2BAA2B;IAC3B,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA,yCAAyC;EACzC;IACE,wBAAwB;EAC1B;;EAEA,sDAAsD;EACtD;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,6CAA6C;IAC7C,sCAAsC;IACtC,wCAAwC;IACxC,wBAAwB;IACxB,wBAAwB;IACxB,sCAAsC;IACtC,iDAAiD;IACjD,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,mCAAmC;EACrC;;EAEA,2CAA2C;EAC3C;IACE,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,6BAA6B;IAC7B,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,yBAAyB;IACzB,oDAAoD;IACpD,oCAAoC;EACtC;;EAEA;IACE,iCAAiC;IACjC,8BAA8B;EAChC;;EAEA,2CAA2C;EAC3C;IACE,wBAAwB;IACxB,gDAAgD;IAChD,oBAAoB;IACpB,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,4BAA4B;IAC5B,4CAA4C;IAC5C,6BAA6B;IAC7B,oCAAoC;IACpC,2BAA2B;IAC3B,kCAAkC;IAClC,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,8CAA8C;IAC9C,iCAAiC;EACnC;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA,2BAA2B;EAC3B;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,8BAA8B;IAC9B,+BAA+B;IAC/B,2CAA2C;EAC7C;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;IAC1B,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,yBAAyB;IACzB,0BAA0B;IAC1B,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA,4DAA4D;EAC5D;IACE,+CAA+C;IAC/C,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA,qDAAqD;EACrD;;;;IAIE,wBAAwB;EAC1B;;EAEA,mDAAmD;EACnD;IACE,wBAAwB;IACxB,uBAAuB;EACzB;;EAEA,8BAA8B;EAC9B;IACE,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,yCAAyC;IACzC,wBAAwB;EAC1B;;EAEA,+CAA+C;EAC/C;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,4CAA4C;IAC5C,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,wBAAwB;IACxB,qCAAqC;EACvC;AACF;AAEA,kBAAkB;AAClB;EACE;IACE,oCAAoC;IACpC,0BAA0B;EAC5B;AACF;AAEA,2BAA2B;AAC3B;EACE;IACE,mDAAmD;IACnD,2CAA2C;EAC7C;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;AACF;AAEA;EACE;IACE,mDAAmD;IACnD,uCAAuC;IACvC,yCAAyC;EAC3C;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,2BAA2B;EAC7B;AACF;AAEA,iCAAiC;AACjC;EACE;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,sCAAsC;IACtC,4DAA4D;IAC5D,4BAA4B;IAC5B,wBAAwB;IACxB,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,uBAAuB;EACzB;;EAEA,sDAAsD;EACtD;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,qCAAqC;IACrC,2BAA2B;IAC3B,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA,mCAAmC;EACnC;IACE,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,sCAAsC;IACtC,yDAAyD;IACzD,wBAAwB;IACxB,yBAAyB;IACzB,wBAAwB;IACxB,oBAAoB;IACpB,kCAAkC;IAClC,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,uBAAuB;IACvB,qDAAqD;IACrD,6BAA6B;IAC7B,uBAAuB;IACvB,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;IAC1B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,mBAAmB;IACnB,oCAAoC;EACtC;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,8BAA8B;EAChC;AACF;AAEA,cAAc;AACd;EACE,wBAAwB;AAC1B;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;AAEA;EACE,yBAAyB;AAC3B;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;AD/SA,0BAA0B;AAC1B;EACE,oCAAoC;EACpC,gBAAgB;AAClB;AAEA;EACE,wBAAwB;AAC1B;AAEA;EACE,iBAAiB;AACnB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,qBAAqB;AACvB;AAGE;EAAA;AAAc;AAId;EAAA,sBAAc;EACd,kBAAwB;EAAxB,qDAAwB;EACxB;AAFc;AAMd;EAAA,kBAAwB;EAAxB,qDAAwB;EACxB;AADwB;AAI1B,wBAAwB;AACxB;EACE,qBAAqB;AACvB;AAGE;EAAA;AAAa;AAIb;EAAA;AAAa;AAIb;EAAA;AAAa;AAIb;EAAA;AAAa","sourcesContent":["/* Import responsive styles */\n@import '../styles/responsive.css';\n\n/* CUSTOM OHIF SCROLLBAR */\n.ohif-scrollbar {\n  scrollbar-color: #173239 transparent;\n  overflow-y: auto;\n}\n\n.ohif-scrollbar-stable-gutter {\n  scrollbar-gutter: stable;\n}\n\n.study-min-height {\n  min-height: 450px;\n}\n\n.ohif-scrollbar:hover {\n  overflow-y: auto;\n}\n\n.ohif-scrollbar::-webkit-scrollbar {\n  scrollbar-width: thin;\n}\n\n.ohif-scrollbar::-webkit-scrollbar-track {\n  @apply rounded;\n}\n\n.ohif-scrollbar::-webkit-scrollbar-thumb {\n  @apply rounded;\n  @apply bg-secondary-dark;\n  background-color: #041c4a;\n}\n\n.ohif-scrollbar::-webkit-scrollbar-thumb:window-inactive {\n  @apply bg-secondary-dark;\n  background-color: #041c4a;\n}\n\n/* INVISIBLE SCROLLBAR */\n.invisible-scrollbar {\n  scrollbar-width: none;\n}\n\n.invisible-scrollbar::-webkit-scrollbar {\n  @apply hidden;\n}\n\n.invisible-scrollbar::-webkit-scrollbar-track {\n  @apply hidden;\n}\n\n.invisible-scrollbar::-webkit-scrollbar-thumb {\n  @apply hidden;\n}\n\n.invisible-scrollbar::-webkit-scrollbar-thumb:window-inactive {\n  @apply hidden;\n}\n","/* Estilos responsive para OHIF Viewer */\n\n/* Mobile-first approach */\n@media (max-width: 768px) {\n  .mobile-layout {\n    /* Optimizaciones específicas para móvil */\n    -webkit-overflow-scrolling: touch;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    user-select: none;\n  }\n\n  /* Header completamente oculto en móvil */\n  .mobile-layout .viewer-header {\n    display: none !important;\n  }\n\n  /* Panel de herramientas móvil - aparece desde abajo */\n  .mobile-tools-panel {\n    position: fixed !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    background: rgba(10, 15, 20, 0.95) !important;\n    backdrop-filter: blur(10px) !important;\n    border-top: 1px solid #2d3748 !important;\n    z-index: 9999 !important;\n    padding: 16px !important;\n    transform: translateY(100%) !important;\n    transition: transform 0.3s ease-in-out !important;\n    max-height: 70vh !important;\n    overflow-y: auto !important;\n  }\n\n  .mobile-tools-panel.open {\n    transform: translateY(0) !important;\n  }\n\n  /* Botón flotante para abrir herramientas */\n  .mobile-tools-button {\n    position: fixed !important;\n    bottom: 20px !important;\n    right: 20px !important;\n    width: 56px !important;\n    height: 56px !important;\n    background: #3182ce !important;\n    border-radius: 50% !important;\n    border: none !important;\n    color: white !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    z-index: 10000 !important;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4) !important;\n    transition: all 0.2s ease !important;\n  }\n\n  .mobile-tools-button:active {\n    transform: scale(0.95) !important;\n    background: #2c5aa0 !important;\n  }\n\n  /* Grid de herramientas en el panel móvil */\n  .mobile-tools-grid {\n    display: grid !important;\n    grid-template-columns: repeat(4, 1fr) !important;\n    gap: 16px !important;\n    padding: 8px 0 !important;\n  }\n\n  .mobile-tool-item {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: center !important;\n    padding: 12px 8px !important;\n    background: rgba(45, 55, 72, 0.6) !important;\n    border-radius: 8px !important;\n    border: 1px solid #4a5568 !important;\n    min-height: 80px !important;\n    justify-content: center !important;\n    text-align: center !important;\n    transition: all 0.2s ease !important;\n  }\n\n  .mobile-tool-item:active {\n    background: rgba(66, 153, 225, 0.3) !important;\n    transform: scale(0.95) !important;\n  }\n\n  .mobile-tool-item .icon {\n    margin-bottom: 4px !important;\n    width: 24px !important;\n    height: 24px !important;\n  }\n\n  .mobile-tool-item .label {\n    font-size: 11px !important;\n    color: #e2e8f0 !important;\n    font-weight: 500 !important;\n    line-height: 1.2 !important;\n  }\n\n  /* Header del panel móvil */\n  .mobile-panel-header {\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    margin-bottom: 16px !important;\n    padding-bottom: 12px !important;\n    border-bottom: 1px solid #4a5568 !important;\n  }\n\n  .mobile-panel-title {\n    color: #e2e8f0 !important;\n    font-size: 18px !important;\n    font-weight: 600 !important;\n  }\n\n  .mobile-panel-close {\n    background: none !important;\n    border: none !important;\n    color: #a0aec0 !important;\n    font-size: 24px !important;\n    padding: 4px !important;\n    cursor: pointer !important;\n  }\n\n  /* Viewport optimizado para móvil - ocupa toda la pantalla */\n  .mobile-viewport {\n    touch-action: pan-x pan-y pinch-zoom !important;\n    height: 100vh !important;\n    width: 100vw !important;\n  }\n\n  /* Ocultar paneles laterales completamente en móvil */\n  .mobile-layout .ohif-scrollbar,\n  .mobile-layout .side-panel,\n  .mobile-layout [class*=\"panel\"],\n  .mobile-layout .resize-handle {\n    display: none !important;\n  }\n\n  /* Asegurar que el viewport ocupe todo el espacio */\n  .mobile-layout .viewport-grid {\n    height: 100vh !important;\n    width: 100vw !important;\n  }\n\n  /* Overlay para cerrar panel */\n  .mobile-panel-overlay {\n    position: fixed !important;\n    top: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    bottom: 0 !important;\n    background: rgba(0, 0, 0, 0.3) !important;\n    z-index: 9998 !important;\n  }\n\n  /* Información del paciente compacta en móvil */\n  .mobile-patient-info {\n    position: fixed !important;\n    top: 10px !important;\n    left: 10px !important;\n    background: rgba(10, 15, 20, 0.8) !important;\n    padding: 8px 12px !important;\n    border-radius: 6px !important;\n    font-size: 12px !important;\n    color: #e2e8f0 !important;\n    z-index: 9000 !important;\n    backdrop-filter: blur(5px) !important;\n  }\n}\n\n/* Tablet styles */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .tablet-layout {\n    /* Estilos específicos para tablet */\n    touch-action: manipulation;\n  }\n}\n\n/* Orientación específica */\n@media (orientation: portrait) and (max-width: 768px) {\n  .mobile-layout {\n    /* Ajustes específicos para modo retrato en móvil */\n    padding-bottom: env(safe-area-inset-bottom);\n  }\n\n  .mobile-header {\n    height: 44px !important;\n  }\n\n  .mobile-panel {\n    top: 44px !important;\n  }\n}\n\n@media (orientation: landscape) and (max-width: 768px) {\n  .mobile-layout {\n    /* Ajustes específicos para modo paisaje en móvil */\n    padding-left: env(safe-area-inset-left);\n    padding-right: env(safe-area-inset-right);\n  }\n\n  .mobile-header {\n    height: 40px !important;\n  }\n\n  .mobile-panel {\n    top: 40px !important;\n    max-width: 280px !important;\n  }\n}\n\n/* Navbar del paciente en móvil */\n@media (max-width: 768px) {\n  .mobile-patient-navbar {\n    position: absolute !important;\n    top: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    background: rgba(0, 0, 0, 0.85) !important;\n    backdrop-filter: blur(10px) !important;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;\n    padding: 8px 12px !important;\n    z-index: 9000 !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: space-between !important;\n    height: 60px !important;\n  }\n\n  /* Viewport móvil con margen superior para el navbar */\n  .mobile-viewport-with-navbar {\n    position: relative !important;\n    flex: 1 !important;\n    width: 100vw !important;\n    height: calc(100vh - 60px) !important;\n    margin-top: 60px !important;\n    background: black !important;\n    overflow: hidden !important;\n  }\n\n  /* Botones de navegación inferior */\n  .mobile-bottom-buttons {\n    position: fixed !important;\n    bottom: 0 !important;\n    left: 0 !important;\n    right: 0 !important;\n    background: rgba(0, 0, 0, 0.9) !important;\n    backdrop-filter: blur(10px) !important;\n    border-top: 1px solid rgba(255, 255, 255, 0.1) !important;\n    padding: 12px !important;\n    z-index: 10000 !important;\n    display: flex !important;\n    gap: 12px !important;\n    justify-content: center !important;\n    height: 72px !important;\n  }\n\n  .mobile-bottom-button {\n    flex: 1 !important;\n    max-width: 150px !important;\n    height: 48px !important;\n    border: 1px solid rgba(255, 255, 255, 0.2) !important;\n    border-radius: 8px !important;\n    color: white !important;\n    font-size: 14px !important;\n    font-weight: 500 !important;\n    cursor: pointer !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    gap: 8px !important;\n    transition: all 0.2s ease !important;\n  }\n\n  .mobile-bottom-button:hover {\n    background: rgba(255, 255, 255, 0.2) !important;\n  }\n\n  .mobile-bottom-button.active {\n    background: #3182ce !important;\n  }\n}\n\n/* Utilities */\n.mobile-hidden {\n  display: none !important;\n}\n\n@media (min-width: 768px) {\n  .mobile-hidden {\n    display: block !important;\n  }\n}\n\n.desktop-hidden {\n  display: block !important;\n}\n\n@media (min-width: 768px) {\n  .desktop-hidden {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
